import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	setConfirmationVisible,
	setFinishScreenVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledBackground,
	StyledButtonsContainer,
	StyledCancelButton,
	StyledCenterContainer,
	StyledClockIcon,
	StyledConfirmButton,
	StyledContainer,
	StyledTimerContainer,
} from './InventoryExchangeComfirmation.styled';

const InventoryExchangeComfirmation: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const otherPlayerInfo = useObservable(rage.inventory.getOtherPlayerInfo());
	const exchangeDelaySec = useObservable(rage.inventory.getExchangeDelaySec());
	const time = Math.max(0, exchangeDelaySec);
	const [isLocalPlayerConfirmedExchange, setIsLocalPlayerConfirmedExchange] =
		useState(false);
	const isExchangeCompleted = useObservable(
		rage.inventory.getIsExchangeCompleted(),
	);
	const isInitialMountRef = useRef(true);

	const buttonDisabled = useMemo(
		() => exchangeDelaySec !== 0,
		[exchangeDelaySec, time],
	);

	const handleConfirm = useCallback(() => {
		if (buttonDisabled) {
			return;
		}

		rage.inventory
			.setIsPlayerConfirmed(true)
			.then(() => setIsLocalPlayerConfirmedExchange(true))
			.catch(() => undefined);
	}, [buttonDisabled]);

	useEffect(() => {
		if (isInitialMountRef.current) {
			isInitialMountRef.current = false;
			return;
		}

		if (isExchangeCompleted) {
			dispatch(setConfirmationVisible(false));
			dispatch(setFinishScreenVisible(true));
		}
	}, [isExchangeCompleted]);

	return (
		<StyledContainer>
			<StyledBackground />
			<StyledCenterContainer>
				<StyledTimerContainer>
					<StyledClockIcon />
					<Text>
						Идёт обмен с {otherPlayerInfo?.nickname ?? 'игроком'} ({time} сек.)
					</Text>
					<Text>
						Если вы не уверены в обмене, то нажмите на кнопку отмены ниже
					</Text>
				</StyledTimerContainer>
				<StyledButtonsContainer>
					<StyledConfirmButton
						disabled={buttonDisabled || isLocalPlayerConfirmedExchange}
						onClick={() => {
							handleConfirm();
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => {
							if (!buttonDisabled && !isLocalPlayerConfirmedExchange) {
								playSound(Sound.LinkCursor);
							}
						}}
					>
						{isLocalPlayerConfirmedExchange
							? 'Ожидание игрока'
							: 'Подтвердить обмен'}
					</StyledConfirmButton>
					<StyledCancelButton
						onClick={() => {
							rage.inventory.setIsPlayerConfirmed(false).catch(() => undefined);
							dispatch(setConfirmationVisible(false));
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						Отменить обмен
					</StyledCancelButton>
				</StyledButtonsContainer>
			</StyledCenterContainer>
		</StyledContainer>
	);
};

export { InventoryExchangeComfirmation };
